var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.198 7a2 2 0 1 0 .057-3.999 2 2 0 0 0-.057 4m-4.78 7.931.01-.666c.018-1.267.568-2.459 1.38-3.314.88-.854 2.02-1.305 3.352-1.286a4.64 4.64 0 0 1 4.6 4.733l-.01.666"
  })));
};
export default SvgUser;